import Swiper from 'swiper'
import { selectAll } from 'helpers/dom'
import { Navigation, Pagination, Scrollbar, Autoplay, A11y } from 'swiper/modules'
import { getOptionsByType, getSelector, defaultSelector } from './swiper-utils'

class SwiperInstanceNative {
  constructor(element, options, config, type) {
    this.element = element
    this.selector = getSelector(this.element, defaultSelector.native.CAROUSEL_SWIPER_SELECTOR)
    this.options = getOptionsByType(this.element, config, type, options)
    this.swiper = this.element
    this.init()
  }

  init() {
    const checkSelectorItems = selectAll(`.${this.selector}`)

    if (!checkSelectorItems.length) {
      return
    }

    if (checkSelectorItems.length > 1) {
      console.error('Swiper: Multiple instances of the same selector are not supported', checkSelectorItems)

      return
    }

    this.swiper = new Swiper(`.${this.selector}`, {
      modules: [Navigation, Pagination, Scrollbar, Autoplay, A11y],
      ...this.options
    })
  }
}

export default SwiperInstanceNative
